var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4999 14.375C7.37115 14.375 7.24865 14.3225 7.1599 14.2294L4.19116 11.1044C4.06241 10.9688 4.02616 10.7688 4.09991 10.5963C4.17366 10.4238 4.34365 10.3125 4.53115 10.3125H5.9374V7.65625C5.9374 7.22562 6.28803 6.875 6.71865 6.875H8.28115C8.71177 6.875 9.0624 7.22562 9.0624 7.65625V10.3125H10.4686C10.6561 10.3125 10.8255 10.4244 10.8993 10.5963C10.973 10.7681 10.9374 10.9681 10.808 11.1044L7.83927 14.2294C7.75115 14.3225 7.62865 14.375 7.4999 14.375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6706 3.07938C10.8506 1.58 9.24312 0.625 7.5 0.625C5.28438 0.625 3.3625 2.16563 2.87688 4.26813C1.26188 4.43813 0 5.79438 0 7.4375C0 9.06063 1.23688 10.3894 2.82375 10.5856C2.8425 10.4225 2.88438 10.26 2.95187 10.1038C3.22 9.47875 3.7825 9.0625 4.6875 9.0625V7.65625C4.6875 6.53625 5.59875 5.625 6.71875 5.625H8.28125C9.40125 5.625 10.3125 6.53625 10.3125 7.65625V9.0625C11.2113 9.0625 11.7781 9.4725 12.0481 10.1038C12.1025 10.23 12.1363 10.3606 12.1588 10.4925C13.7925 10.0581 15 8.58438 15 6.83313C15 4.91688 13.5581 3.3175 11.6706 3.07938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloud);
export default __webpack_public_path__ + "static/media/icon-cloud.897c5b9a2d9a471f47c9fc45fadf75d1.svg";
export { ForwardRef as ReactComponent };